export default "/images/frontPageBackgroundImage2-1920x1080.jpg?0aa0ca7e8a67a0ca425659585f240dd8";